import { render, staticRenderFns } from "./xsjl.vue?vue&type=template&id=1435cf43&scoped=true"
import script from "./xsjl.vue?vue&type=script&lang=js"
export * from "./xsjl.vue?vue&type=script&lang=js"
import style0 from "./xsjl.vue?vue&type=style&index=0&id=1435cf43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435cf43",
  null
  
)

export default component.exports